module.exports = __webpack_public_path__ + "static/slider-img-three-6fa448a4ec526f778fd11e29a6cb2630.jpg";